/**
 * Generated runtime TestId mirror for frontend/src/pages/Accounts.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const AccountsTestIds = {
  accountsList: "accounts-list",
  colCreatedAt: "col-created-at",
  colIdentity: "col-identity",
  colStatus: "col-status",
  colTargetSystem: "col-target-system",
  accountSystemSubtitle: (account_id: string) => `account-system-subtitle-${account_id}`,
  accountSystemSubtitlePrefix: () => "account-system-subtitle-" as TestIdPrefix,
  linkAccountIdentity: (account_id: string) => `link-account-identity-${account_id}`,
  linkAccountIdentityPrefix: () => "link-account-identity-" as TestIdPrefix,
  linkAccountSystem: (account_id: string) => `link-account-system-${account_id}`,
  linkAccountSystemPrefix: () => "link-account-system-" as TestIdPrefix
} as const;
